import Icons from "../Config/Images";
import { tableHeaderStyle, tableInputStyle } from "../Utils/CommonStyles/muTableStyle";
import { userStatus } from "./AppConstants";

// const CustomerTableCellHeader = (onViewUserDetails, onEditUserDetails, handleShowDeleteModal) => [
//   {
//     name: "User Name",
//     selector: (row) => `${row?.user_first_name} ${row?.user_last_name}`,
//     style: tableInputStyle,
//   },
//   {
//     name: "Shop Name",
//     selector: (row) => row?.shop_name,
//     style: tableInputStyle,
//   },
//   {
//     name: "State",
//     selector: (row) => row?.state,
//     style: tableInputStyle,
//   },
//   {
//     name: "District",
//     selector: (row) => row?.district,
//     style: tableInputStyle,
//   },
//   {
//     name: "City",
//     selector: (row) => row?.city,
//     style: tableInputStyle,
//   },
//   {
//     name: "Mobile No",
//     selector: (row) => row?.user_mobile_number,
//     style: tableInputStyle,
//   },
//   {
//     name: "Joining Date",
//     selector: (row) => row?.joining_date,
//     style: tableInputStyle,
//   },
//   {
//     name: "Status",
//     selector: (row) => row?.status,
//     style: tableInputStyle,
//   },
//   {
//     name: "Out of Stock",
//     selector: (row) => row?.out_of_stock,
//     style: tableInputStyle,
//   },
//   {
//     name: "Status",
//     selector: (row) => userStatus[row?.user_status_id]?.label || 'Unknown',
//     cell: (row) => (
//       <div
//         style={{
//           backgroundColor: userStatus[row?.user_status_id]?.color || '#e0e0e0',
//           padding: '5px 10px',
//           borderRadius: '4px',
//           color: '#fff', // Text color for better contrast
//           textAlign: 'center'
//         }}
//       >
//         {userStatus[row?.user_status_id]?.label || 'Unknown'}
//       </div>
//     ),
//     style: tableInputStyle,
//   },
//   {
//     name: "Wallet balance",
//     selector: (row) => row?.wallet_balance,
//     style: tableInputStyle,
//   },
//   {
//     name: "Last Login Date",
//     selector: (row) => row?.last_login_date,
//     style: tableInputStyle,
//   },
//   {
//     name: "Last Order Date",
//     selector: (row) => row?.last_order_date,
//     style: tableInputStyle,
//   },
//   {
//     name: "Total Order Value",
//     selector: (row) => row?.total_order_value,
//     style: tableInputStyle,
//   },
//   {
//     name: "Total Order Count",
//     selector: (row) => row?.total_order_count,
//     style: tableInputStyle,
//   },
//   {
//     name: "Action",
//     cell: (row) => (
//       <div style={{ display: "flex", justifyContent: "flex-end" }}>
//         <img
//           src={Icons.previewIcon}
//           style={{ height: "20px", width: "20px", cursor: "pointer" }}
//           onClick={() => onViewUserDetails(row)}
//           alt="Preview Icon"
//         />
//         <img
//           src={Icons.editIcon}
//           style={{
//             height: "20px",
//             width: "20px",
//             cursor: "pointer",
//             marginLeft: "20px",
//           }}
//           onClick={() => onEditUserDetails(row)}
//           alt="Edit Icon"
//         />
//         <img
//           src={Icons.deleteIcon}
//           style={{
//             height: "20px",
//             width: "20px",
//             cursor: "pointer",
//             marginLeft: "20px",
//           }}
//           onClick={() => handleShowDeleteModal(row?.order_id)}
//           alt="Delete Icon"
//         />
//       </div>
//     ),
//     style: tableInputStyle,
//   },
// ];

const customerTableCellHeader = [
  {
    id: 1,
    header: "Sr No", // Added Serial Number header
  },
  {
    id: 2,
    header: "User Name",
  },
  {
    id: 3,
    header: "Shop Name",
  },
  {
    id: 4,
    header: "State",
  },
  {
    id: 5,
    header: "City",
  },
  {
    id: 6,
    header: "Mobile Number",
  },
  {
    id: 7,
    header: "Joining Date",
  },
  {
    id: 8,
    header: "Status",
  },
  {
    id: 9,
    header: "Wallet Balance",
  },
  {
    id: 10,
    header: "Last seen date",
  },
  {
    id: 11,
    header: "Last Order Date",
  },
  {
    id: 12,
    header: "Total Order value",
  },
  {
    id: 13,
    header: "Total Order count",
  },
  {
    id: 14,
    header: "Action",
  },
];

const ManufacturesTableCellHeader =  [
  {
    id: 1,
    header: 'Sr No.',
  },
  {
    id: 3,
    header: "Shop Name",
  },
  {
    id: 3,
    header: "State",
  },
  {
    id: 4,
    header: "City",
  },
  {
    id: 5,
    header: "Category",
  },
  {
    id: 6,
    header: "Last Order Date",
  },
  {
    id: 7,
    header: "Total Order Value",
  },
  {
    id: 8,
    header: "Total Product",
  },
  {
    id: 9,
    header: "Out of Stock",
  },
  {
    id: 10,
    header: "Status",
  },
  {
    id: 11,
    header: "Rating",
  },
  {
    id: 12,
    header: "Total Order Count",
  },
  {
    id: 13,
    header: "Action",
  },
];

const productTableCellHeader = [
  {
    id: 1,
    header: "Sr No",
  },
  {
    id: 2,
    header: "Product Name",
  },
  {
    id: 3,
    header: "Product Category",
  },
  {
    id: 4,
    header: "Sub Category",
  },
  {
    id: 5,
    header: "Metal",
  },
  {
    id: 6,
    header: "Brand Name",
  },
  {
    id: 7,
    header: "Per Pcs Weight(gm)",
  },
  {
    id: 8,
    header: "Stock",
  },
  {
    id: 9,
    header: "Status",
  },
  {
    id: 10,
    header: "Action",
  },
];

const productPurityTableCellHeader = [
  {
    id: 1,
    header: 'Sr No',
  },
  {
    id: 2,
    header: " Product Metal Purity id",
  },
  {
    id: 3,
    header: "Product Metal Purity Value",
  },
  {
    id: 4,
    header: "Action",
  },
];

const productMetalTableCellHeader = [
  {
    id: 1,
    header: "Sr No",
  },
  {
    id: 2,
    header: " Product Metal Name",
  },
  {
    id: 3,
    header: "Action",
  },
];

const productCategoryTableCellHeader = [
  {
    id: 1,
    header: "Sr No",
  },
  {
    id: 2,
    header: " Product Category Name",
  },
  {
    id: 3,
    header: "Action",
  },
];

const menuTableCellHeader = [
  {
    id: 1,
    header: "Sr No",
  },
  {
    id: 2,
    header: "Menu Title",
  },
  {
    id: 3,
    header: "Action",
  },
];

const pageTableCellHeader = [
  {
    id: 1,
    header: "Sr No",
  },
  {
    id: 2,
    header: "Page Name",
  },
  {
    id: 3,
    header: "Action",
  },
];

const rolePermissionTableHeader = [
  {
    id: 1,
    header: "View",
  },
  {
    id: 2,
    header: "Create",
  },
  {
    id: 3,
    header: "Edit",
  },
  {
    id: 4,
    header: "Delete",
  },
];

const stateDashboardData = [
  {
    id: 1,
    state: "Rajasthan",
    client: "425",
    sale: "4,25,560",
  },
  {
    id: 2,
    state: "Gujarat",
    client: "455",
    sale: "4,25,560",
  },
  {
    id: 3,
    state: "Maharastra",
    client: "425",
    sale: "4,25,560",
  },
  {
    id: 4,
    state: "Uttar Pradesh",
    client: "365",
    sale: "4,25,560",
  },
  {
    id: 5,
    state: "Madhya Pradesh",
    client: "365",
    sale: "4,25,560",
  },
  {
    id: 6,
    state: "Madhya Pradesh",
    client: "365",
    sale: "4,25,560",
  },
  {
    id: 7,
    state: "Madhya Pradesh",
    client: "365",
    sale: "4,25,560",
  },
  {
    id: 8,
    state: "Madhya Pradesh",
    client: "365",
    sale: "4,25,560",
  },
];

const trendingItemsData = [
  {
    id: 1,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 2,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 3,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 4,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 5,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 6,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 7,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
  {
    id: 8,
    items: "Nosepin",
    client: "98",
    quantity: "965pcs",
  },
];

const brandNameData = [
  {
    id: 1,
    srNo: "1",
    brandName: "Aman",
  },
  {
    id: 2,
    srNo: "2",
    brandName: "Aman",
  },
  {
    id: 3,
    srNo: "3",
    brandName: "Aman",
  },
  {
    id: 4,
    srNo: "4",
    brandName: "Aman",
  },
  {
    id: 5,
    srNo: "5",
    brandName: "Aman",
  },
];

const clientNameData = [
  {
    id: 1,
    srNo: "1",
    clientName: "Aman",
  },
  {
    id: 2,
    srNo: "2",
    clientName: "Aman",
  },
  {
    id: 3,
    srNo: "3",
    clientName: "Aman",
  },
  {
    id: 4,
    srNo: "4",
    clientName: "Aman",
  },
  {
    id: 5,
    srNo: "5",
    clientName: "Aman",
  },
];

const ProductListData = (
  onViewProductDetails,
  onEditProductDetails,
  handleShowDeleteModal
) => [
  {
    name: "Product ID",
    selector: (row) => row.product_id,
    style: tableInputStyle,
  },
  {
    name: "Product Name",
    selector: (row) => row?.product_name,
    style: tableInputStyle,
  },
  {
    name: "Product Category",
    selector: (row) => row?.product_category,
    style: tableInputStyle,
  },
  {
    name: "Product Sub-Category",
    selector: (row) => row?.product_sub_category,
    style: tableInputStyle,
  },
  {
    name: "Product Metal",
    selector: (row) => row?.product_metal,
    style: tableInputStyle,
  },
  {
    name: "Per pcs weight",
    selector: (row) => row?.per_pcs_weight,
    style: tableInputStyle,
  },
  {
    name: "Stock",
    selector: (row) => row?.stock,
    style: tableInputStyle,
  },
  {
    name: "Status",
    selector: (row) => row?.status,
    style: tableInputStyle,
  },
  {
    name: "Action",
    cell: (row) => (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <img
          src={Icons.previewIcon}
          style={{ height: "20px", width: "20px", cursor: "pointer" }}
          onClick={() => onViewProductDetails(row)}
          alt="Preview Icon"
        />
        <img
          src={Icons.editIcon}
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
            marginLeft: "20px",
          }}
          onClick={() => onEditProductDetails(row)}
          alt="Edit Icon"
        />
        <img
          src={Icons.deleteIcon}
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
            marginLeft: "20px",
          }}
          onClick={() => handleShowDeleteModal(row?.order_id)}
          alt="Delete Icon"
        />
      </div>
    ),
    style: tableInputStyle,
  },
];

const productListLeftSideData = [
  {
    name: "Gross Weight",
    selector: (row) => row.product_gross_weight,
    style: tableInputStyle,
  },
  {
    name: "Less Weight",
    selector: (row) => row?.product_less_weight,
    style: tableInputStyle,
  },
  {
    name: "Net Weight",
    selector: (row) => row?.product_net_weight,
    style: tableInputStyle,
  },
  {
    name: "Quantity",
    selector: (row) => row?.product_quantity,
    style: tableInputStyle,
  },
];

const productListRightSideData = [
  {
    name: "Stamp",
    selector: (row) => row.product_gross_weight,
    style: tableInputStyle,
  },
  {
    name: "Melting (Purity)",
    selector: (row) => row?.product_less_weight,
    style: tableInputStyle,
  },
  {
    name: "Wastage for Retailer",
    selector: (row) => row?.product_net_weight,
    style: tableInputStyle,
  },
  {
    name: "Rate",
    selector: (row) => row?.product_quantity,
    style: tableInputStyle,
  },
  {
    name: "Per Pcs for Retailer",
    selector: (row) => row?.product_quantity,
    style: tableInputStyle,
  },
];

const productListRightSideWholesalerData = [
  {
    name: "labour of wholesaler",
    selector: (row) => row.product_gross_weight,
    style: tableInputStyle,
  },
  {
    name: "Melting (Purity)",
    selector: (row) => row?.product_less_weight,
    style: tableInputStyle,
  },
  {
    name: "Wastage for wholesaler",
    selector: (row) => row?.product_net_weight,
    style: tableInputStyle,
  },
  {
    name: "Rate",
    selector: (row) => row?.product_quantity,
    style: tableInputStyle,
  },
  {
    name: "Per Pcs for wholesaler",
    selector: (row) => row?.product_quantity,
    style: tableInputStyle,
  },
];

const OrderTableCellHeader = [
  {
    id: 1,
    header: "Sr No.",
  },
  {
    id: 2,
    header: "User Name",
  },
  {
    id: 3,
    header: "Shop Name",
  },
  {
    id: 4,
    header: "Brand Name",
  },
  {
    id: 5,
    header: "Order Number",
  },
  {
    id: 6,
    header: "Date",
  },
  {
    id: 7,
    header: "Total Price",
  },
  {
    id: 8,
    header: "Status",
  },
  {
    id: 9,
    header: "Action",
  },
];


const stateColumn = [
  {
    header: "State",
  },
  {
    header: "Client",
  },
  {
    header: "Sale",
  },
];


const trendingItemColumn = [
  {
    header: "Products",
  },
  {
    header: "Quantity (pcs)",
  },
  {
    header: "Client",
  },
];

const brandHeaderData = [
  {
    header: "Sr No",
  },
  {
    header: "Brands",
  },
];

const clientHeaderData = [
  {
    header: "Sr No",
  },
  {
    header: "Clients",
  },
];

const transportTableCellHeader = [
  {
    header: "Sr No",
  },
  {
    header: "Name of Transport",
  },
  {
    header: "Head Office ",
  },
  {
    header: "Mobile Number",
  },
  {
    header: "Alt .Mobile Number",
  },
  {
    header: "Service Number",
  },
  {
    header: "Status",
  },
  {
    header: "Action",
  },
]
export {
  brandHeaderData,
  clientHeaderData,
  customerTableCellHeader,
  productTableCellHeader,
  productPurityTableCellHeader,
  productMetalTableCellHeader,
  productCategoryTableCellHeader,
  rolePermissionTableHeader,
  stateDashboardData,
  trendingItemsData,
  brandNameData,
  clientNameData,
  ManufacturesTableCellHeader,
  ProductListData,
  productListLeftSideData,
  productListRightSideData,
  productListRightSideWholesalerData,
  OrderTableCellHeader,
  menuTableCellHeader,
  pageTableCellHeader,
  stateColumn,
  trendingItemColumn,
  transportTableCellHeader
};
